"use client";

import ImageWithListCard from "@/revamp/molecules/ImageWithListCard";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";
import clsx from "clsx";
import style from "./HolisticCareer.module.scss";

export default function HolisticCareerServicesSection({ data, isSpecificPage=false }) {
  return (
    <div className="Carousel">
      <Carousel
        children={data.map((item, index) => (
          <ImageWithListCard {...item} key={index} Id={`card-img-${index}`} isSpecificPage={isSpecificPage} />
        ))}
        className={clsx("!my-0", style.holistic_career_carousel)}
        config={{
          autoplay: {
            status: false,
            delay: 6000,
          },
          spaceBetween: 20,
          slidesPerView: 1,
          pagination: {
            className: "program_detail_carousel_pagination text-center my-4",
          },
          breakpoints: {
            320: {
              slidesPerView: 1
            },
            400: {
              slidesPerView: 1.2,
              spaceBetween: 5
            },
            481: {
              slidesPerView: 1.4,
              spaceBetween: 5
            },
            768: {
              slidesPerView: 2.2,
              spaceBetween: 5
            },
            900: {
              slidesPerView: 2.5,
              spaceBetween: 5
            },
            1201: {
              slidesPerView: 3.4,
              spaceBetween: 5
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 10
            }
          }
        }}
      />

    </div>
  );
}
